import { render, staticRenderFns } from "./Barcodes.vue?vue&type=template&id=6302d8b2&"
import script from "./Barcodes.vue?vue&type=script&lang=js&"
export * from "./Barcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QBtn,QDialog,QCard,QCardSection,QInput,QSelect,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh,QBtn,QDialog,QCard,QCardSection,QInput,QSelect,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
